import moment from 'moment';

type FormatExportNameOptions = {
  exportType?: string;
  replaceSpecialChar?: string;
  dateFormat?: string;
  extension?: string;
};

const DEFAULT_EXPORT_NAME_OPTIONS = {
  exportType: '',
  replaceSpecialChar: '_',
  dateFormat: 'YYYY-MM-DD',
  extension: '',
};

export const formatExportName = (resourceName: string, options: FormatExportNameOptions = DEFAULT_EXPORT_NAME_OPTIONS) => {
  const { exportType, replaceSpecialChar, dateFormat, extension } = { ...DEFAULT_EXPORT_NAME_OPTIONS, ...options };

  const name = [resourceName.replaceAll(/[^\w]/g, replaceSpecialChar), moment(moment.now()).format(dateFormat), exportType].filter((p) => !!p).join('_');
  if (!extension) {
    return name;
  }
  return `${name}.${extension}`;
};
